import { endpoints } from 'modules/endpoints'
import { createBasicManagers } from 'modules/utils/helpers/createBasicManagers'
import { octopusApiClient } from 'modules/utils/httpClient'
import { ListResponse } from 'types/api'
import {
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  TargetSkuUpdateDTO,
  PedigreedTargetSku,
  PedigreedTargetSkuCreateDTO,
} from '../common/types'

const pedigreedTargetSkuManagers = {
  ...createBasicManagers<
    TargetSkuListRequestFilter,
    TargetSkuListRequestSorting,
    PedigreedTargetSku,
    PedigreedTargetSkuCreateDTO,
    TargetSkuUpdateDTO
  >(endpoints.pedigreedTargetSku, octopusApiClient),
  getList: (
    filter: TargetSkuListRequestFilter,
    sorting: TargetSkuListRequestSorting,
    page: number,
    pageSize?: number,
  ) => {
    try {
      return octopusApiClient.get<ListResponse<PedigreedTargetSku>>(endpoints.pedigreedTargetSku(), {
        ...filter,
        ...sorting,
        page: page,
        page_size: pageSize,
        order_by: 'territory_asc',
      })
    } catch (err) {
      console.error('List fetch error!', err)
      throw err
    }
  },
}

export default pedigreedTargetSkuManagers
